<vcl-modal id="termsModal" [modalTitle]="terms.title" *ngIf="terms" [(showModal)]="showModal" [buttonLabels]="buttonLabelsModal" (modalButtonClick)="modalAction($event)">
  <p id="pdfText" [innerHtml]="terms.text"></p>
</vcl-modal>

<div class="content-with-stepper-and-title back-document-scan">
  <div class="row">
    <div class="col-4 col-sm-8 col-md-12 col-lg-12 col-xl-12">
      <div class="title">
        <h1 id="backDocTitle" [innerHTML]="copyService.copies.back_document_title"></h1>
      </div>

      <div class="animation">
        <lottie-animation-view id="backDocAnimation" class="image" [options]="image" [width]="200"></lottie-animation-view>
      </div>

      <!-- <div class="checkbox">
        <voxel-checkbox [id]="'backDocCheckboxTerms'" [label]="checkboxTerms.label" [checked]="checkboxTerms.checked" name="terms" [value]="checkboxTerms.value" (checkboxChange)="checkboxChange($event)">
        </voxel-checkbox>
      </div> -->
<!-- 
      <div class="link">
        <vcl-link [linkId]="'backDocTermsLink'"(click)="toggleModal()" [label]="copyService.copies.back_document_link_label">
        </vcl-link>
      </div> -->
    </div>
  </div>
  <app-controls id="backDocBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.back_document_button" (next)="next()"></app-controls>
</div>
